module.exports = __webpack_public_path__ + "static/media/html.07b7972b.svg";